import { render, staticRenderFns } from "./articulos.vue?vue&type=template&id=371988e1"
import script from "./articulos.vue?vue&type=script&lang=js"
export * from "./articulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports